module.exports = __webpack_public_path__ + "static/008400-cc3025a9c829e959c04c73588d499116.jpg";